import * as React from 'react';
import { BasePureComponent } from './BaseComponent';
import * as Glob from '../Globale';
import { ENGINE_METHOD_NONE } from 'constants';

interface IBarraPercentualeProps {
    Valore: number;
    ValoreMassimo: number;
    Etichetta?: string;
    pctRed?: number;
    pctYellow?: number;
    pctGreen?: number;
}

export class BarraPercentuale extends BasePureComponent<IBarraPercentualeProps> {
    public constructor(props: any) {
        super(props);
    }

    public render() {

        let valori: any[] = [];

        let valoreCalcolato: number = Number((100 / this.props.ValoreMassimo * this.props.Valore).toFixed(0));

        let Indice: string = ""
        Indice = valoreCalcolato.toString() + "%";
        let margin: string = "0";

        for (let i: number = 0; i <= 100; i++) {
            let valore: any[] = [];
            let css: string = "";

            if (i == valoreCalcolato) {
                if (valoreCalcolato < 10)
                    margin = "-7px";
                else if (valoreCalcolato >= 10 && valoreCalcolato < 100)
                    margin = "-9px"
                else
                    margin = "-12px";
                valori.push(<div className="arrowIndicator"></div>);
                valori.push(<div style={{ color: Glob.GetColorForPercentage(i / 100, i, 100, this.props.pctRed, this.props.pctYellow, this.props.pctGreen), marginLeft: margin, marginRight: margin }} >{Indice}</div>);
                css = "selected";
            }
            valori.push(<div className={"progress-bar " + css} key={"bar_" + i} role="progressbar" style={{ marginTop: "56px", height: "10px", backgroundColor: Glob.GetColorForPercentage(i / 100, i, i, this.props.pctRed, this.props.pctYellow, this.props.pctGreen), width: "1%" }} aria-valuenow={i} aria-valuemin={0} aria-valuemax={100}></div>);
        }

        valori.push(<div key={"bar_101"} style={{ width: "30px" }}></div>);

        return <div className="kt-widget24" style={{ height: "auto" }}>
            <div className="kt-widget24__content">
                <div className="kt-widget24__item">

                    <div className="kt-widget24__info">
                        <div className="kt-widget24__progress">
                            <div className="progress kt-progress--sm" style={{ height: "66px", backgroundColor: "transparent" }}>
                                {valori}
                            </div>
                            <div className="kt-widget24__action">
                                <span className="kt-widget24__change">
                                    <h4 className="kt-widget24__title">
                                        {this.props.Etichetta}
                                    </h4>
                                </span>
                                <span className="kt-widget24__number">

                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>;
    }
}



// WEBPACK FOOTER //
// ./src/components/BarraPercentuale.tsx